import { Component, ViewEncapsulation } from '@angular/core';
import '@fitnesspassport/wc-unverified-user';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ManageUsersComponent {
  url = environment.employersGraphApiUrl
}